export enum SignEnum {
  Positive = 1,
  Negative = -1,
}
